/*
 * quick-add-mythos.js — comportement du pop-up d'ajout rapide (refonte Mythos).
 *
 * Auto-sélection de la première taille disponible : quand on change de métal,
 * le picker re-render tout #quick-buy-modal-content avec la taille courante
 * encore cochée même si elle est indispo pour ce métal. On observe le contenu
 * du modal et, dès que la taille cochée devient indisponible, on bascule sur la
 * première taille disponible (déclenche un nouveau rendu via l'event natif).
 *
 * Scopé au quick-buy (.qa-mythos) — la fiche produit n'est pas touchée.
 */
(function () {
  function isAvailable(fieldset, input) {
    if (input.disabled) return false;
    var label = null;
    try { label = fieldset.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]'); } catch (e) {}
    if (!label) label = input.nextElementSibling;
    return !(label && label.classList.contains('is-disabled'));
  }

  function fixSizes(modal) {
    // Le fieldset taille = l'option qui n'est pas le métal (métal = .swatch-bg-img)
    var fieldset = modal.querySelector('.qa-mythos .variant-picker__option:not(.swatch-bg-img)');
    if (!fieldset) return;
    var inputs = Array.prototype.slice.call(fieldset.querySelectorAll('input[data-option-position]'));
    if (!inputs.length) return;

    var checked = inputs.filter(function (i) { return i.checked; })[0];
    // Taille courante dispo → rien à faire (évite toute boucle)
    if (checked && isAvailable(fieldset, checked)) return;

    var firstAvailable = inputs.filter(function (i) { return isAvailable(fieldset, i); })[0];
    if (firstAvailable && firstAvailable !== checked) {
      firstAvailable.checked = true;
      firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  var observed = new WeakSet();
  function watch(modal) {
    if (observed.has(modal)) return;
    observed.add(modal);
    var obs = new MutationObserver(function () {
      clearTimeout(modal._qaTimer);
      modal._qaTimer = setTimeout(function () { fixSizes(modal); }, 60);
    });
    obs.observe(modal, { childList: true, subtree: true });
  }

  function scan() {
    document.querySelectorAll('quick-buy-modal').forEach(watch);
  }

  // Préchargement de la fiche produit au survol du bouton d'ajout rapide : le
  // modal fetch toute la page produit à l'ouverture (1er clic = aller-retour
  // réseau, d'où des images de carrousel un peu lentes). En préchargeant au
  // survol, le document est déjà en cache quand on clique.
  var prefetched = {};
  function prefetchProduct(handle) {
    if (!handle || prefetched[handle]) return;
    prefetched[handle] = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = root + 'products/' + handle;
    document.head.appendChild(link);
  }
  document.addEventListener('pointerenter', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.product-card__quick-add-button');
    if (!btn) return;
    var id = btn.getAttribute('aria-controls');
    var modal = id && document.getElementById(id);
    if (modal && modal.tagName === 'QUICK-BUY-MODAL') prefetchProduct(modal.getAttribute('handle'));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Attrape les modals ajoutés plus tard (cross-sell du cart drawer, etc.)
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) { scan(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

/*
 * Mobile uniquement : un quick-buy ouvert PAR-DESSUS le panier glisse depuis la
 * droite comme un drawer (au lieu du bottom-sheet natif), avec croix de
 * fermeture. Scopé au seul contexte panier (cart-drawer ouvert au moment du
 * clic) ; partout ailleurs le bottom-sheet d'origine est conservé. Desktop
 * (>=700px) : aucun changement, on retombe sur l'animation du thème.
 */
(function () {
  var EASE = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
  function isMobile() { return window.matchMedia('(max-width: 699px)').matches; }
  function cartOpen() { return !!document.querySelector('cart-drawer[open]'); }

  // Wrapper aligné sur l'interface attendue par le moteur de dialog du thème
  // (.finished : Promise, .finish() : saute à la fin, .stop() : annule).
  function controls(anims) {
    return {
      finished: Promise.all(anims.map(function (a) { return a.finished; })),
      finish: function () { anims.forEach(function (a) { try { a.finish(); } catch (e) {} }); },
      stop: function () { anims.forEach(function (a) { try { a.cancel(); } catch (e) {} }); }
    };
  }

  function sideAnimation(el, opening) {
    var overlay = el.getShadowPartByName('overlay');
    var content = el.getShadowPartByName('content');
    // À la fermeture on garde l'état final (panneau hors-écran) jusqu'au
    // display:none pour éviter un flash de retour en place.
    var fill = opening ? 'none' : 'forwards';
    var anims = [];
    if (overlay) {
      anims.push(overlay.animate(
        { opacity: opening ? [0, 1] : [1, 0] },
        { duration: 300, easing: EASE, fill: fill }
      ));
    }
    if (content) {
      anims.push(content.animate(
        { transform: opening ? ['translateX(100%)', 'translateX(0)'] : ['translateX(0)', 'translateX(100%)'] },
        { duration: 300, easing: EASE, fill: fill }
      ));
    }
    return controls(anims);
  }

  customElements.whenDefined('quick-buy-modal').then(function () {
    var QB = customElements.get('quick-buy-modal');
    if (!QB || QB.__mythosDrawerPatched) return;
    QB.__mythosDrawerPatched = true;

    var proto = QB.prototype;
    var ModalProto = Object.getPrototypeOf(proto);
    var origShow = proto.show || ModalProto.show;
    var origEnter = ModalProto.createEnterAnimationControls;
    var origLeave = ModalProto.createLeaveAnimationControls;

    // Marque le contexte au moment de l'ouverture : la classe pilote à la fois
    // le layout (CSS) et le choix de l'animation ci-dessous.
    proto.show = function () {
      this.classList.toggle('qb-from-cart', cartOpen());
      return origShow.apply(this, arguments);
    };

    proto.createEnterAnimationControls = function () {
      if (isMobile() && this.classList.contains('qb-from-cart')) return sideAnimation(this, true);
      return origEnter.call(this);
    };
    proto.createLeaveAnimationControls = function () {
      if (isMobile() && this.classList.contains('qb-from-cart')) return sideAnimation(this, false);
      return origLeave.call(this);
    };
  });

  // Le quick-buy est déplacé dans <body> à l'ouverture : un clic sur sa croix
  // (ou son backdrop) est donc "hors panier" et la focus-trap du cart le
  // referme. On neutralise ça côté cart, sur mobile uniquement : un clic dont
  // la cible est dans un quick-buy ne doit jamais fermer le panier → fermer le
  // quick-buy nous ramène au panier (« si on change d'avis »). Desktop intact.
  customElements.whenDefined('cart-drawer').then(function () {
    var CD = customElements.get('cart-drawer');
    if (!CD || CD.__mythosCartGuard) return;
    CD.__mythosCartGuard = true;
    var origHideForOutside = CD.prototype.hideForOutsideClickTarget
      || Object.getPrototypeOf(CD.prototype).hideForOutsideClickTarget;
    CD.prototype.hideForOutsideClickTarget = function (target) {
      if (isMobile() && target && target.closest && target.closest('quick-buy-modal')) return false;
      return origHideForOutside.call(this, target);
    };
  });
})();
